import css from 'styled-jsx/css';

const SponsorDisplayLeftStyles = css`
  .sponsored-display-left {
    margin-bottom: 16px;
  }
`;

export { SponsorDisplayLeftStyles };
